import { brandConfig } from '../../config';

export default function fTitle(title: string) {
  const trimmedTitle = title.trim();
  return `${trimmedTitle} | ${brandConfig.name}`;
}
